import * as React from 'react'
// libs
import { FieldArray, WrappedFieldArrayProps } from 'redux-form'
// components
import { ReduxSelect } from 'components/FormElements/ReduxForm'
import renderSubConditions from 'components/Modals/SystemProcessModal/Form/components/Conditions/components/SubConditions'
// constants
import { CONDITION_TYPE_OPTIONS } from 'constants/systemProcesses'
// views
import { Wrapper, Title } from './views'
import { AddButton, ConditionWrapper } from 'components/Modals/SystemProcessModal/Form/components/views'

const renderConditions: React.FC<WrappedFieldArrayProps<any>> = ({ fields }) => {
  return (
    <>
      <Title>Conditions</Title>

      {fields.map((field, index) => {
        const removeField = () => fields.remove(index)

        return (
          <React.Fragment key={field}>
            <Wrapper>
              <FieldArray<any>
                name={`${field}.conditions`}
                removeSubField={removeField}
                groupIndex={index}
                component={renderSubConditions}
              />
            </Wrapper>

            {fields.length - index >= 2 && (
              <ConditionWrapper>
                <ReduxSelect name={`${field}.conditionType`} options={[CONDITION_TYPE_OPTIONS[0]]} placeholder={''} />
              </ConditionWrapper>
            )}
          </React.Fragment>
        )
      })}

      <AddButton
        data-testid='system-process-add-condition-group'
        onClick={() =>
          fields.push({
            conditions: [{ conditionType: CONDITION_TYPE_OPTIONS[1] }],
            conditionType: CONDITION_TYPE_OPTIONS[0]
          })
        }>
        + add a condition to this process
      </AddButton>
    </>
  )
}

export default renderConditions
